<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 20,
      height: 20,
      color: 'currentColor',
      viewBoxValue: `0 0 20 20`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      d="M14 9L9.5 13L5 9"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
